import Radio from 'backbone.radio';


var globalCh = Radio.channel('global');
/**
 * Switch active accounts for the entire IDE
 * @param account a v5 Account
 */
function change_active_account(account, cb) {
    var primary_account = globalCh.request('primary_account');
    primary_account.fetch_permissions_for_account(account).done(()=>{
        // Don't try switching to accounts on which we have no permissions
        if (account.permits(primary_account).length === 0) {
            return globalCh.request('not_found',
                "Unable to view account '" + account.get('username') + "'");
        }

        globalCh.request('setActiveAccount', account);

        // Save the account UUID as a hint to our future selves, so if the user
        // refreshes the IDE we'll know who the model belongs to
        localStorage.setItem('last_used_account', account.id);

        globalCh.request('fetchEverything', function() {
            if (cb) { cb(account); }
        });
    }).catch(()=>{
        return globalCh.request('not_found',
            "Unable to view account '" + account.get('username') + "'");
    });

}
export default change_active_account;
